@for (dataElement of publicData(); track dataElement) {
  <div
    class="my-2 pr-3 flex items-end gap-0.5 flex-wrap"
    [class.separated-right]="!$last"
    [attr.data-testid]="dataElement.testId"
  >
    <div class="nx-font-weight-bold">{{ dataElement.i18n | translate }}:</div>
    @for (subPart of dataElement.data; track $index) {
      @if (subPart.style) {
        <span class="flex gap-0.5 nx-font-weight-{{ subPart.style }}">
          {{ subPart.mustTranslate ? (subPart.text | translate) : subPart.text }}
          @if (subPart.iconName) {
            <nx-icon [attr.data-testid]="subPart.iconName" class="pt-1" [name]="subPart.iconName" />
          }
        </span>
      } @else {
        {{ subPart.mustTranslate ? (subPart.text | translate) : subPart.text }}
      }
    } @empty {
      -
    }
  </div>
}
